import * as React from "react";
export const Col = props => React.createElement("div", { className: "g-col" }, props.children);
